import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GalleryDto } from '@picflow/types';
import { BillingScope } from 'apps/picflow/src/app/billing-consts';
import { randomString } from '../../../../lib/random-string';
import { AnalyticsService } from '../../../../services/analytics.service';
import { BillingScopePipe } from '../../../../shared-extra/pipes/billing-scope.pipe';
import { TransitionPreventorDirective } from '../../../../shared/directives/transition-preventor.directive';

@Component({
  selector: 'app-action-box-switch',
  templateUrl: './action-box-switch.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TransitionPreventorDirective, FormsModule, BillingScopePipe],
})
export class ActionBoxSwitchComponent {
  id = randomString(12);
  @Input({ required: true }) switchValue: boolean;
  @Input() overridePermissionIfTrue: boolean;
  @Input() gallery: GalleryDto;
  @Input() scope: BillingScope;
  @Input() disabled: boolean;
  @Input() name: string;
  @Input() location: string;
  @Output() onSwitch = new EventEmitter<boolean>();

  private analytics = inject(AnalyticsService);

  switch(value: boolean) {
    this.analytics.track('toggle-switch', false, { name: this.name, location: this.location, value });
    this.onSwitch.emit(value);
  }
}
